<div class="category-form">
    <div class="form-content">
        <!-- Loading indicator -->
        <div *ngIf="isLoading" class="loading-container">
            <mat-spinner diameter="40"></mat-spinner>
            <p>{{ 'request_v2.category_form.loading' | translate }}</p>
        </div>

        <form [formGroup]="categoryForm" *ngIf="!isLoading">
            <!-- Step 1: Visual and names -->
            <div *ngIf="currentStep === 1" class="step-content">
                <div class="section-title">{{ 'request_v2.category_form.category_visual' | translate }}</div>

                <div class="visual-layout">
                    <app-icon-color-selector
                        [isVisible]="isDropdownVisible"
                        [selectedIcon]="categoryForm.get('visual.icon')?.value"
                        [selectedColor]="categoryForm.get('visual.color')?.value"
                        [icons]="icons"
                        [colors]="colors"
                        (iconSelect)="onIconSelect($event)"
                        (colorSelect)="onColorSelect($event)"
                        (close)="isDropdownVisible = false"
                    >
                    </app-icon-color-selector>

                    <div class="icon-container">
                        <div class="icon-preview-container">
                            <div class="icon-preview" [style.backgroundColor]="categoryForm.get('visual.color')?.value" (click)="toggleDropdownVisibility($event)">
                                <i [class]="categoryForm.get('visual.icon')?.value"></i>
                                <mat-icon class="chevron-icon">expand_more</mat-icon>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="section-title">{{ 'request_v2.category_form.category_name' | translate }}</div>

                <div class="name-form" formGroupName="name">
                    <div class="bilingual-row">
                        <app-form-input-v2
                            [label]="'request_v2.category_form.english_name' | translate"
                            [type]="'text'"
                            [invalidPass]="formErrors['nameEn'] && categoryForm.get('name.en')?.touched"
                            [invalidText]="'request_v2.category_form.required_field' | translate"
                            formControlName="en"
                        >
                            <app-form-error *ngIf="formErrors['nameEn'] && categoryForm.get('name.en')?.touched">
                                {{ 'request_v2.category_form.required_field' | translate }}
                            </app-form-error>
                        </app-form-input-v2>

                        <app-form-input-v2
                            [label]="'request_v2.category_form.french_name' | translate"
                            [type]="'text'"
                            [invalidPass]="formErrors['nameFr'] && categoryForm.get('name.fr')?.touched"
                            [invalidText]="'request_v2.category_form.required_field' | translate"
                            formControlName="fr"
                        >
                            <app-form-error *ngIf="formErrors['nameFr'] && categoryForm.get('name.fr')?.touched">
                                {{ 'request_v2.category_form.required_field' | translate }}
                            </app-form-error>
                        </app-form-input-v2>
                    </div>
                </div>

                <div class="section-title">{{ 'request_v2.category_form.category_description' | translate }}</div>

                <div class="description-section" formGroupName="description">
                    <div class="bilingual-row">
                        <div class="input-group">
                            <app-form-textarea [label]="'request_v2.category_form.english_description' | translate" [rows]="4" [wordLimit]="80" formControlName="en">
                                <div class="validation-error" *ngIf="formErrors['descriptionEn'] && categoryForm.get('description.en')?.touched">
                                    {{ 'request_v2.category_form.required_field' | translate }}
                                </div>
                            </app-form-textarea>
                        </div>

                        <div class="input-group">
                            <app-form-textarea [label]="'request_v2.category_form.french_description' | translate" [rows]="4" [wordLimit]="80" formControlName="fr">
                                <div class="validation-error" *ngIf="formErrors['descriptionFr'] && categoryForm.get('description.fr')?.touched">
                                    {{ 'request_v2.category_form.required_field' | translate }}
                                </div>
                            </app-form-textarea>
                        </div>
                    </div>
                </div>

                <!-- Location Options -->
                <div class="privacy-options">
                    <label class="custom-checkbox">
                        <input type="checkbox" [formControl]="forceLocationControl"/>
                        <span class="checkbox-box"></span>
                        <span class="checkbox-label">{{ 'request_v2.category_form.force_location' | translate }}</span>
                    </label>
                    <div class="hint-text">{{ 'request_v2.category_form.force_location_hint' | translate }}</div>
                </div>

                <!-- Internal category Options -->
                <div class="privacy-options">
                    <label class="custom-checkbox">
                        <input type="checkbox" [formControl]="isInternal"/>
                        <span class="checkbox-box"></span>
                        <span class="checkbox-label">{{ 'request_v2.category_form.is_internal' | translate }}</span>
                    </label>
                    <div class="hint-text">{{ 'request_v2.category_form.is_internal_hint' | translate }}</div>
                </div>

                <!-- Privacy Options -->
                <div class="privacy-options">
                    <label class="custom-checkbox">
                        <input type="checkbox" [formControl]="forcePrivateRequestsControl" />
                        <span class="checkbox-box"></span>
                        <span class="checkbox-label">{{ 'request_v2.category_form.force_private_requests' | translate }}</span>
                    </label>
                    <div class="hint-text">{{ 'request_v2.category_form.force_private_requests_hint' | translate }}</div>
                </div>

                <div class="section-title">
                    {{ 'request_v2.category_form.category_statuses' | translate }}
                    <button mat-icon-button class="add-status-button" (click)="addStatus()">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>

                <div class="status-section">
                    <div class="status-list" formArrayName="statuses">
                        <div
                            class="status-item"
                            *ngFor="let status of statuses.controls; let i = index"
                            [formGroupName]="i"
                            [ngStyle]="{ 'background-color': getStatusBgColor(status.get('color').value) }"
                        >
                            <div class="status-indicator" [style.backgroundColor]="status.get('color').value"></div>
                            <div class="status-names" formGroupName="name">
                                <span class="status-name">{{ status.get('name.en').value }} / {{ status.get('name.fr').value }}</span>
                                <span class="validation-error" *ngIf="formErrors['status' + i + 'En'] || formErrors['status' + i + 'Fr']">
                                    {{ 'request_v2.category_form.status_name_error' | translate }}
                                </span>
                            </div>
                            <button
                                mat-icon-button
                                class="remove-status-button"
                                *ngIf="status.get('isDeletable').value"
                                [disabled]="statuses.length <= 1"
                                (click)="removeStatus(i); $event.stopPropagation()"
                            >
                                <mat-icon>close</mat-icon>
                            </button>
                        </div>
                    </div>

                    <!-- Add status selector dropdown -->
                    <div class="status-selector" *ngIf="!loadingStatuses && filteredAvailableStatuses.length > 0">
                        <app-searchable-dropdown
                            [label]="'request_v2.category_form.select_status' | translate"
                            [placeholder]="'request_v2.category_form.select_status' | translate"
                            [items]="filteredAvailableStatuses"
                            [selectedItems]="selectedStatusItems"
                            [multiSelect]="true"
                            [currentLang]="currentLang"
                            [showSelectedInInput]="true"
                            [loading]="loadingStatuses"
                            (itemSelect)="onItemSelect($event)"
                            (itemDeselect)="onItemDeselect($event)"
                        >
                            <ng-template #itemTemplate let-item>
                                <div class="dropdown-status-item" [class.selected]="isStatusSelected(item.id || item.value)">
                                    <div class="status-color-indicator" [style.backgroundColor]="item.color"></div>
                                    <span class="status-name">{{ item.label }}</span>
                                    <mat-icon *ngIf="isStatusSelected(item.id || item.value)" class="selected-indicator">check</mat-icon>
                                </div>
                            </ng-template>
                        </app-searchable-dropdown>
                    </div>

                    <!-- Inline Status form -->
                    <div class="inline-status-form" *ngIf="statusFormVisible">
                        <div class="inline-status-form-container">
                            <form [formGroup]="statusForm" (ngSubmit)="saveStatus()">
                                <div class="section-title">{{ 'request_v2.status_form.create_status' | translate }}</div>
                                <div class="status-form-row">
                                    <div class="status-input-group">
                                        <div class="name-inputs" formGroupName="name">
                                            <app-form-input-v2
                                                [label]="'request_v2.category_form.english_status_name' | translate"
                                                [type]="'text'"
                                                [invalidPass]="statusForm.get('name').get('en').touched && statusForm.get('name').get('en').hasError('required')"
                                                [invalidText]="'request_v2.category_form.required_field' | translate"
                                                formControlName="en"
                                            >
                                                <app-form-error class="status-error-message" *ngIf="statusForm.get('name').get('en').touched && statusForm.get('name').get('en').hasError('required')">
                                                    {{ 'request_v2.category_form.required_field' | translate }}
                                                </app-form-error>
                                            </app-form-input-v2>

                                            <app-form-input-v2
                                                [label]="'request_v2.category_form.french_status_name' | translate"
                                                [type]="'text'"
                                                [invalidPass]="statusForm.get('name').get('fr').touched && statusForm.get('name').get('fr').hasError('required')"
                                                [invalidText]="'request_v2.category_form.required_field' | translate"
                                                formControlName="fr"
                                            >
                                                <app-form-error class="status-error-message" *ngIf="statusForm.get('name').get('fr').touched && statusForm.get('name').get('fr').hasError('required')">
                                                    {{ 'request_v2.category_form.required_field' | translate }}
                                                </app-form-error>
                                            </app-form-input-v2>
                                        </div>

                                        <div class="status-type-wrapper">
                                            <div class="form-field-container">
                                                <app-form-select-v2
                                                    [label]="'request_v2.status_form.status_type' | translate"
                                                    [placeholder]="'request_v2.status_form.select_status_type' | translate"
                                                    formControlName="statusType"
                                                    [options]="statusTypeOptions"
                                                    [invalid]="statusForm.get('statusType').touched && statusForm.get('statusType').hasError('required')"
                                                >
                                                    <app-form-error *ngIf="statusForm.get('statusType').touched && statusForm.get('statusType').hasError('required')">
                                                        {{ 'request_v2.status_form.type_required' | translate }}
                                                    </app-form-error>
                                                </app-form-select-v2>
                                            </div>
                                        </div>
                                    </div>

                                    <button mat-icon-button class="close-status-form-button" (click)="hideStatusForm()">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                </div>

                                <div class="save-button-container">
                                    <button mat-flat-button class="save-button" id="status-form-save-button" type="submit">
                                        {{ 'request_v2.category_form.save' | translate }}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Step 2 - Subjects and SLAs section -->
            <div class="form-section" *ngIf="currentStep === 2">
                <div class="subjects-section">
                    <div class="section-title">{{ 'request_v2.category_form.relation' | translate }}</div>

                    <app-searchable-dropdown
                        [label]="'request_v2.category_form.select_subjects' | translate"
                        [placeholder]="'request_v2.category_form.search_subjects' | translate"
                        [items]="subjects"
                        [selectedItems]="selectedSubjects"
                        [multiSelect]="true"
                        [showAddOption]="true"
                        [currentLang]="currentLang"
                        [loading]="loadingSubjects"
                        [showSelectedInInput]="true"
                        (itemSelect)="toggleSubjectSelection($event)"
                        (itemDeselect)="toggleSubjectSelection($event)"
                        (createNew)="showCreateSubjectForm($event)"
                    ></app-searchable-dropdown>

                    <div class="sla-section">
                        <div class="section-title">{{ 'request_v2.category_form.slas' | translate }}</div>

                        <!-- Category SLA -->
                        <div class="sla-form-group">
                            <div class="sla-input-row">
                                <div class="subject-name">
                                    {{ 'request_v2.category_form.category_sla' | translate }}
                                </div>
                                <div class="sla-input-wrapper">
                                    <input type="number" min="1" class="sla-number-input" [required]="true" (change)="onCategorySlaChange($event.target.value)" formControlName="categorySLA" />
                                    <span class="days-label">{{ 'request_v2.category_form.days' | translate }}</span>
                                </div>
                            </div>
                            <!-- Category SLA validation error message -->
                            <div class="validation-error" *ngIf="formErrors.categorySLAMissing">
                                {{ 'request_v2.category_form.category_sla_required' | translate }}
                            </div>
                        </div>

                        <!-- Subject SLAs -->
                        <div class="subject-slas" *ngIf="subCategories.controls.length > 0" formArrayName="subCategories">
                            <div class="subject-sla-item" *ngFor="let subCatCtrl of subCategories.controls; let i = index" [formGroupName]="i">
                                <div class="sla-input-row">
                                    <div class="subject-name">
                                        {{ subCatCtrl.get('name.en')?.value }} / {{ subCatCtrl.get('name.fr')?.value || ('request_v2.category_form.new_subject' | translate) }}
                                    </div>
                                    <div class="sla-input-wrapper">
                                        <input type="number" min="1" max="999" class="sla-number-input" required formControlName="slaInDays" />
                                        <span class="days-label">{{ 'request_v2.category_form.days' | translate }}</span>
                                    </div>
                                </div>
                                <!-- Department Selector -->
                                <div class="subject-department-item" [class.has-error]="formErrors.subjectDepartmentsMissing && !hasSubjectDepartment(subCatCtrl.get('_id')?.value)">
                                    <app-select-list-v2
                                        [label]="'request_v2.category_form.select_department' | translate"
                                        [placeholder]="'request_v2.category_form.select_department_placeholder' | translate"
                                        [items]="availableDepartments"
                                        itemValueField="_id"
                                        itemDisplayField="name"
                                        formControlName="departmentId"
                                        (selectionChange)="onSubCategoryDepartmentChange(subCatCtrl, $event)"
                                    >
                                    </app-select-list-v2>
                                </div>
                            </div>
                            <!-- Subject SLAs validation error message -->
                            <div class="validation-error" *ngIf="formErrors.subjectSLAsMissing">
                                {{ 'request_v2.category_form.all_subject_slas_required' | translate }}
                            </div>
                            <!-- Department validation error message -->
                            <div class="validation-error" *ngIf="formErrors.subjectDepartmentsMissing">
                                {{ 'request_v2.category_form.all_subject_departments_required' | translate }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
